import React from "react";
import { useParams} from 'react-router-dom';

export default function Return() {
  const {connectedAccountId} = useParams();

  return (
    <div className="container">
      <div className="banner">
        <h2>Kodosan</h2>
      </div>
      <div className="content">
        <h2>Details submitted</h2>
        <p>That's everything we need for now</p>
      </div>
    </div>
  );
}
